import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from '@paypalcorp/pp-react';
import _isEmpty from 'lodash/isEmpty';
import { fetchTopicTree } from '../../../../js/contactUs/actions/action-message-topic-tree';
import { CONTACT_TOPIC_TREE_INTENTS } from '../../../common/storeConstants';
import { getPersonalizedFeed } from '../../../components/topicIntentSection/TopicIntents-Actions';
import TopicIntents from '../../../components/topicIntentSection/TopicIntents';
import OcpPromptSelectionBar from '../../../components/topicIntentSection/OcpPromptSelectionBar';
import TopicIntentSearchSheet from '../../../components/topicIntentSection/TopicIntentSearchSheet';
import TopicIntentFinalSelectionBar from '../../../components/topicIntentSection/TopicIntentFinalSelectionBar';

// TODO :  Can we fire the fpti in the components rather than here ? Make a call and pass it upstream.
const TopicTreeIntentsPanel = function (props) {
  const { pageName, FPTIData } = props;
  const { priorityIntents } = useSelector((state) => state[CONTACT_TOPIC_TREE_INTENTS]);

  const dispatch = useDispatch();

  useEffect(() => {
    // TODO: use the new getContactTopicTreeIntents api instead of fetchTopicTree api
    if (_isEmpty(priorityIntents)) {
      dispatch(fetchTopicTree());
    }
    // get the personalized feed data - OCP data
    dispatch(getPersonalizedFeed());
  }, []);

  return (
    <Container className="sh_topic_intent__panel" data-testid="sh-topic-intent-panel">
      <TopicIntents pageName={pageName} FPTIData={FPTIData} />
      <TopicIntentFinalSelectionBar FPTIData={FPTIData} />
      <TopicIntentSearchSheet FPTIData={FPTIData} />
      <OcpPromptSelectionBar />
    </Container>
  );
};

TopicTreeIntentsPanel.propTypes = {
  pageName: PropTypes.string.isRequired,
  FPTIData: PropTypes.shape({}).isRequired,
};

export default TopicTreeIntentsPanel;
